/**
 * RouteOne ids of lenders that need behaviour of their own somewhere in the app.
 * These are the values configured as `route_one_id` in Lender Management.
 */
export const ROUTE_ONE_LENDER_ID = {
  ARRA_FINANCE: 'FTC116',
  ALLY: 'F000BA',
  AMERICREDIT: 'F00DG4',
  MTB: 'F000B1',
} as const;

export const ARRA_FINANCE_DEFAULT_BACK_ADDS = 3000;

/**
 * A lender's configured `route_one_id` may carry a variant suffix (e.g. `FTC116-NO`) while still
 * being the same RouteOne lender, which is why identity is matched on the leading id instead of
 * strict equality - the same way `useLenderMode` matches it against the SSO external lender id.
 */
export const isRouteOneLender = (configuredRouteOneId: string | null | undefined, routeOneLenderId: string): boolean =>
  !!configuredRouteOneId && configuredRouteOneId.trim().toUpperCase().startsWith(routeOneLenderId);
